module.exports = __webpack_public_path__ + "img/sec_img1.865cfefc.png";